import { lazy } from 'react';

const AddExperienceTrackingEntryModal = lazy(
  () =>
    import('modules/StudentProfile/components/AddExperienceTrackingEntryModal'),
);

const PortfolioFileViewerModal = lazy(
  () =>
    import(
      'modules/StudentProfile/components/PortfolioSection/components/PortfolioFileViewerModal'
    ),
);

const ChoicesModal = lazy(
  () => import('modules/StudentProfile/components/ChoicesModal'),
);

const PreferredPronounsModal = lazy(
  () => import('modules/StudentProfile/components/PreferredPronounsModal'),
);

const PreferredNameModal = lazy(
  () => import('modules/StudentProfile/components/PreferredNameModal'),
);

const VideoQuestionModal = lazy(
  () => import('modules/StudentProfile/components/VideoQuestionModal'),
);

const EditVisibilityModal = lazy(
  () =>
    import(
      'modules/StudentProfile/components/AcademicsSection/EditVisibilityModal'
    ),
);

const ReferencesModal = lazy(
  () => import('modules/StudentProfile/components/ReferencesModal'),
);

export default {
  ADD_EXPERIENCE_TRACKING_ENTRY_MODAL: AddExperienceTrackingEntryModal,
  CHOICES_MODAL: ChoicesModal,
  PORTFOLIO_FILE_VIEWER_MODAL: PortfolioFileViewerModal,
  PREFERRED_NAME_MODAL: PreferredNameModal,
  PREFERRED_PRONOUNS_MODAL: PreferredPronounsModal,
  VIDEO_QUESTION_MODAL: VideoQuestionModal,
  EDIT_VISIBILITY_MODAL: EditVisibilityModal,
  REFERENCES_MODAL: ReferencesModal,
};
